<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div>
      <v-snackbar
        v-model="snackbar"
        :right="x === 'right'"
        :timeout="timeout"
        :top="y === 'top'"
      >
        {{ errorMsg }}
        <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </div>

    <v-toolbar flat color="white">
      <v-toolbar-title>Package Details</v-toolbar-title>
    </v-toolbar>
    <v-card>
      <v-card-text>
        <v-layout row>
          <v-spacer></v-spacer>
          <v-container grid-list-md>
            <v-layout row>
              <v-flex xs12 sm6 md4>
                <v-select
                  v-model="editedItem.package_id"
                  :items="indexData.packages.data"
                  v-if="indexData.packages"
                  item-text="name"
                  item-value="id"
                  box
                  label="Select Package"
                ></v-select>
              </v-flex>
              <v-btn color="blue darken-1" flat @click="show">Show</v-btn>
              <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            </v-layout>
            <div v-if="loadData">
              <v-data-table
                v-model="editedItem.services"
                :headers="urlHeaders"
                :items="indexData.services"
                item-key="id"
                :search="search"
                select-all
                class="elevation-1"
                show-select
                hide-actions
              >
                <template v-slot:items="props">
                  <td>
                    <v-checkbox
                      v-model="props.selected"
                      selected
                      primary
                      hide-details
                    ></v-checkbox>
                  </td>
                  <td class="text-xs-left">{{ props.item.id }}</td>
                  <td class="text-xs-left">{{ props.item.name }}</td>
                  <td class="text-xs-left" v-if="checkSelected(props.item.id)">
                    <P v-if="!input_type(props.item.id)"> Allowed </P>
                    <v-select
                      v-else-if="props.item.id==8"
                      :items="indexData.roles"
                      v-model="editedItem.allowed_roles"
                      item-text="name"
                      item-value="id"
                      :rules="[(v) => !!v || 'This is required!']"
                      label="select roles"
                      multiple
                    ></v-select>
                    <v-text-field
                      v-else
                      v-model="props.item.max_limit"
                      :rules="[(v) => !!v || 'This is required!']"
                      label="max limit"
                    ></v-text-field>
                  </td>
                  <td class="text-xs-left" v-else>N/A</td>
                </template>
              </v-data-table>
              <v-layout row v-if="indexData.assignPackageServices">
                <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
              </v-layout>
            </div>
          </v-container>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    dialog: false,
    search: "",
    snackbar: false,
    y: "top",
    x: "right",
    timeout: 4000,
    apiUrl: "package-details",
    items: [
      { name: "Yes", value: 1 },
      { name: "No", value: 2 },
    ],
    urlHeaders: [
      {
        text: "Service Name",
        align: "left",
        value: "name",
        sortable: false,
      },
      {
        text: "Permission",
        align: "left",
        value: "id",
        sortable: false,
      },
    ],
    editedIndex: -1,
    previousData: [],
    max_array: [1, 2, 4, 6, 7, 8, 19, 20, 21, 22],
    editedItem: {
      services: [],
      package_id: "",
      allowed_roles: [],
    },
    defaultItem: {
      services: [],
      package_id: "",
      allowed_roles: [],
    },
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
    formTitle() {
      return this.editedIndex === -1
        ? "Assign Url To Role"
        : "Edit Url To Role";
    },
    loadData() {
      if (this.indexData.services) {
        return this.getSelected();
      } else {
        return false;
      }
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.$store.dispatch("setIndexData", [this.apiUrl]);
    },
    checkSelected(value) {
      if (this.editedItem.services.find((x) => x.id === value)) {
        return true;
      } else {
        return false;
      }
    },

    setErrorZero() {
      this.$store.dispatch("setErrorZero");
    },
    input_type(value) {
      return this.max_array.includes(value);
    },
    getSelected() {
      if (this.indexData.assignPackageServices) {
        this.editedItem.services = this.indexData.assignPackageServices;
        return true;
      } else {
        return false;
      }
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    show() {
      // console.log(this.editedItem.package_id);
      this.$store.dispatch("indexData", [
        "assign.package-to-service",
        this.editedItem.package_id,
      ]);
    },

    save() {
      // eslint-disable-next-line no-console
      // console.log(this.editedItem);
      this.$store.dispatch("storeOrUpdate", [
        "package-details",
        this.editedItem,
      ]);
      this.snackbar = true;
      this.close();
    },
  },
};
</script>
<style scoped>
.tbl-border {
  border: 1px solid #000;
}
.table-th {
  border: 1px solid #000;
}
</style>
